import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { AppSessionStorage } from "../utils/app-session-storage-utils";
import { AppConfigService } from "../app-config.service";

@Component({
  selector: "app-ask-ramsys",
  templateUrl: "./ask-ramsys.component.html",
  styleUrls: ["./ask-ramsys.component.scss"],
})
export class AskRamsysComponent implements OnInit, AfterViewInit {
  iframeUrl?: string;
  @ViewChild("iframeElement") iframeElement!: ElementRef<HTMLIFrameElement>;
  session_token?: string;
  errorMessage?: string;

  constructor(private authenticationService: AuthenticationService, private appConfigService: AppConfigService) { }

  ngOnInit() {
    const configuredUrl = this.appConfigService.appConfig?.ASK_RAMSYS_URL;
    if (configuredUrl && this.isValidUrl(configuredUrl)) {
      this.iframeUrl = configuredUrl ;
    } else {
      this.errorMessage = configuredUrl
        ? "URL is invalid. Please update the configuration."
        : "URL is missing from the configuration.";
      return;
    }
    this.session_token = this.authenticationService.getAuthToken();
  }

  ngAfterViewInit() {
    if (!this.iframeUrl || !this.session_token) {
      return;
    }
    let user = AppSessionStorage.getUser();
    this.iframeElement.nativeElement.onload = () => {
      const message = { session: this.session_token, user: user };
      this.iframeElement.nativeElement.contentWindow?.postMessage(message, this.iframeUrl);
    }
  }

  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }
}
